<script>
import auctionTimer from "../components/auctionTimer";

export default {
  name: "bidder-toolbar",
  components: {
    auctionTimer,
  },
  props: {
    refreshBidList: Number,
  },
  data: function() {
    return {};
  },
  methods: {
    async getBids() {
      var self = this;
      if (self.activeBid) {
        var newActive = self.bids.filter(function(x) {
          return x.offerId == self.activeBid.offerId;
        })[0];
        self.$store.commit("setActiveBid", newActive);
      } else {
        self.$store.commit("setActiveBid", self.bids[0]);
      }
    },
    async getOfferInfo(id) {
      return await this.$store.dispatch("getRequest", { controller: "Offer", method: `${id}` });
    },
    onBidClick: function() {
      if (this.activeBid.withdrawn) {
        this.$store.commit("setMessage", { title: "Unable To Bid", type: "error", content: `Your vessel has been withdrawn from the auction. Unable to bid.` });
      } else if (this.activeBid.lowestBid) {
        this.$store.commit("setMessage", { title: "Unable To Bid", type: "error", content: `Your vessel already has the lowest bid!` });
      } else {
        this.$store.commit("setBidModalVisible", true);
      }
    },
    onAutoBidClick: function() {
      if (this.activeBid.withdrawn) {
        this.$store.commit("setMessage", { title: "Unable To Bid", type: "error", content: `Your vessel has been withdrawn from the auction. Unable to bid.` });
      } else {
        this.$store.commit("setAutoBidModalVisible", true);
      }
    },
    async onWithdrawClick() {
      if (this.activeBid.withdrawn) {
        this.$store.commit("setMessage", { title: "Vessel Already Withdrawn", type: "error", content: `Your vessel has already been withdrawn from the auction.` });
      } else {
        var canWithdraw = confirm("Are you sure you want to withdraw this vessel from the auction?  This action cannot be undone.");
        if (canWithdraw) {
          var self = this;
          return await self.$store.dispatch("getRequest", { controller: "Auction", method: `WithdrawVessel/${self.auctionId}`, parameters: { bidId: self.activeBid.offerId } });
        }
      }
    },
    onMultiVesselDealClick: function() {
      if (this.activeBid.withdrawn) {
        this.$store.commit("setMessage", { title: "Unable To Bid", type: "error", content: `Your vessel has been withdrawn from the auction. Unable to bid.` });
      } else {
        this.$store.commit("setMultiVesselDealVisible", true);
      }
    },
  },
  computed: {
    activeBid: function() {
      return this.$store.state.activeBid || false;
    },
    bids: function() {
      return this.$store.state.activeAuction.bids;
    },
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    multipleBids: function() {
      return this.bids && this.bids.length > 1;
    },
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    auctionStatus: function() {
      return this.$store.state.activeAuction.status;
    },
    isLowestBid: function() {
      return this.activeBid ? this.activeBid.lowestBid : false;
    },
    statusDisplay: function() {
      return this.activeBid ? (this.isLowestBid ? "Lowest Bid" : "Not Lowest") : "-";
    },
    bidFormatted: function() {
      var bid = this.activeBid.currentRate;
      return `${bid.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${this.currency}`;
    },
    bidLimitFormatted: function() {
      var bid = this.activeBid.bidLimit;
      return `${bid.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${this.currency}`;
    },
    bidDropdownData: function() {
      return this.bids.map(function(o) {
        return { Key: o.offerId, Value: o.vesselName };
      });
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  async mounted() {
    this.getBids();
  },
  watch: {
    async refreshBidList() {
      await this.getBids();
    },
  },
};
</script>
<template>
  <div>
    <div class="col-12">
      <div class="row">
        <div style="border-top:1px solid #ced4da;width:100%;margin-left:15px;margin-right:15px;margin-top:0.5rem;margin-bottom:0.5rem;"></div>
        <div :class="[isMobile ? 'col-4' : 'col-3']">
          <span class="title-text">Vessel</span><br />
          <span class="content-text">{{ activeBid ? activeBid.offer.VesselVesselName : "-" }}</span>
        </div>
        <div :class="[isMobile ? 'col-4' : 'col-3']">
          <span class="title-text"><span v-if="auctionStatus == 'Unstarted'">Starting Bid</span><span v-else-if="auctionStatus == 'In Progress'">Current Bid</span><span v-else>Final Bid</span></span
          ><br />
          <span class="content-text">{{ activeBid ? bidFormatted : "-" }}</span> <i v-if="activeBid.autoBid" class="fas fa-gavel icon-right" :title="`Auto-bid is currently turned on with a bid limit of ${bidLimitFormatted}. Click here to edit`" v-on:click="onAutoBidClick"></i>
        </div>
        <div :class="[isMobile ? 'col-4' : 'col-3']">
          <span class="title-text">Status</span><br />
          <span v-if="activeBid.withdrawn" class="content-text" style="color:grey;font-weight:bold;"><i>Withdrawn</i></span>
          <span v-else-if="auctionStatus != 'Unstarted'" class="content-text" :class="activeBid ? (isLowestBid ? 'lowest-bid' : 'not-lowest-bid') : ''">{{ statusDisplay }}</span>
          <span v-else>-</span>
        </div>
        <div class="col-3" v-if="!isMobile">
          <auction-timer style="float:right"></auction-timer>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <span class="title-text">Actions <i class="withdrawn-text" v-if="activeBid.withdrawn"> (Disabled) - Your vessel has been withdrawn from the auction</i></span
          ><br />
          <b-button-group class="d-flex button-group" :class="[isMobile ? 'mobile' : '']">
            <b-button :disabled="auctionStatus != 'In Progress' || !activeBid" class="btn-light" v-on:click.stop="onBidClick()">Bid</b-button>
            <b-button :disabled="auctionStatus != 'In Progress' || !activeBid" class="btn-light" v-on:click.stop="onAutoBidClick()">Autobid</b-button>
            <b-button :disabled="auctionStatus != 'In Progress' || !activeBid" class="btn-light" v-on:click.stop="onWithdrawClick()">Withdraw</b-button>
            <b-button v-if="bids.length > 1" :disabled="auctionStatus != 'In Progress'" class="btn-light" v-on:click.stop="onMultiVesselDealClick()">Package Offer</b-button>
          </b-button-group>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.bid-details {
  background-color: #004996;
  color: white;
  padding: 0.5rem;
}
.context-text {
  font-size: 18px;
}
.title-text {
  font-size: 12px;
}
.lowest-bid {
  color: green;
}
.not-lowest-bid {
  color: red;
}
.button-group > button:first-child {
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
}
.button-group > button:last-child {
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
}
.fa-gavel {
  color: #004996;
  cursor: pointer;
}
.withdrawn-text {
  color: gray;
}
.button-group.mobile > button {
  font-size: 12px;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>
